import { render, staticRenderFns } from "./AttachTriggerToParamModal.vue?vue&type=template&id=4f4112c6"
import script from "./AttachTriggerToParamModal.vue?vue&type=script&lang=js"
export * from "./AttachTriggerToParamModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports